export default function Eligibility() {
  return (
    <div>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, var(--primary-color) 0%, #0052a3 100%)',
        color: 'white',
        padding: '40px 28px',
        borderRadius: '12px',
        marginBottom: '40px',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          margin: '0 0 12px 0',
          lineHeight: '1.2'
        }}>
          Eligibility Criteria
        </h1>
        <p style={{
          fontSize: '16px',
          margin: 0,
          opacity: '0.95'
        }}>
          Check if you qualify for our programs
        </p>
      </div>

      {/* Youth Category */}
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        marginBottom: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        borderLeft: '4px solid #3b82f6'
      }}>
        <h2 style={{
          fontSize: '20px',
          fontWeight: '700',
          marginBottom: '20px',
          color: 'var(--text-dark)',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          margin: '0 0 20px 0'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            background: '#3b82f6' + '15',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#3b82f6',
            fontSize: '18px'
          }}>
            <i className="ti ti-users" aria-hidden="true"></i>
          </div>
          Youth Entrepreneurs (18-35 years)
        </h2>
        <ul style={{
          paddingLeft: '24px',
          color: 'var(--text-secondary)',
          lineHeight: '2',
          fontSize: '14px'
        }}>
          <li>Be between 18-35 years old</li>
          <li>Have a registered or planned business</li>
          <li>Be a citizen of the country</li>
          <li>Meet income eligibility criteria</li>
          <li>Provide valid identification documents</li>
          <li>Have a working mobile phone for transactions</li>
        </ul>
      </div>

      {/* Woman Category */}
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        marginBottom: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        borderLeft: '4px solid #ec4899'
      }}>
        <h2 style={{
          fontSize: '20px',
          fontWeight: '700',
          marginBottom: '20px',
          color: 'var(--text-dark)',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          margin: '0 0 20px 0'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            background: '#ec4899' + '15',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ec4899',
            fontSize: '18px'
          }}>
            <i className="ti ti-user-circle" aria-hidden="true"></i>
          </div>
          Women Entrepreneurs (Any age)
        </h2>
        <ul style={{
          paddingLeft: '24px',
          color: 'var(--text-secondary)',
          lineHeight: '2',
          fontSize: '14px'
        }}>
          <li>Be female, any age</li>
          <li>Have a business or income-generating activity</li>
          <li>Be a citizen of the country</li>
          <li>Have dependents or community impact</li>
          <li>Provide valid identification documents</li>
          <li>Demonstrate business commitment</li>
        </ul>
      </div>

      {/* Disability Category */}
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        marginBottom: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        borderLeft: '4px solid #f59e0b'
      }}>
        <h2 style={{
          fontSize: '20px',
          fontWeight: '700',
          marginBottom: '20px',
          color: 'var(--text-dark)',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          margin: '0 0 20px 0'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            background: '#f59e0b' + '15',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#f59e0b',
            fontSize: '18px'
          }}>
            <i className="ti ti-accessibility" aria-hidden="true"></i>
          </div>
          Persons with Disabilities
        </h2>
        <ul style={{
          paddingLeft: '24px',
          color: 'var(--text-secondary)',
          lineHeight: '2',
          fontSize: '14px'
        }}>
          <li>Have certified disability</li>
          <li>Be engaged in any economic activity</li>
          <li>Be a citizen of the country</li>
          <li>Demonstrate business commitment</li>
          <li>Provide valid identification documents</li>
          <li>Have disability certification from relevant authority</li>
        </ul>
      </div>

      {/* General Requirements */}
      <div style={{
        background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)',
        borderRadius: '12px',
        padding: '32px',
        border: '2px solid #10b981' + '30',
        marginBottom: '24px'
      }}>
        <h2 style={{
          fontSize: '20px',
          fontWeight: '700',
          marginBottom: '20px',
          color: '#065f46',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          margin: '0 0 20px 0'
        }}>
          <i className="ti ti-circle-check" style={{ fontSize: '24px' }} aria-hidden="true"></i>
          General Requirements (All Categories)
        </h2>
        <ul style={{
          paddingLeft: '24px',
          color: '#047857',
          lineHeight: '2',
          fontSize: '14px'
        }}>
          <li>Must be at least 18 years old</li>
          <li>Valid national identification document</li>
          <li>Active mobile phone number</li>
          <li>Bank account or access to one</li>
          <li>No criminal record related to fraud</li>
          <li>Meet poverty/income threshold criteria</li>
          <li>Willing to participate in program requirements</li>
        </ul>
      </div>

      {/* FAQ Section */}
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <h2 style={{
          fontSize: '20px',
          fontWeight: '700',
          marginBottom: '24px',
          color: 'var(--text-dark)',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <i className="ti ti-help-circle" style={{ color: 'var(--primary-color)', fontSize: '24px' }} aria-hidden="true"></i>
          Frequently Asked Questions
        </h2>
        <div style={{ display: 'grid', gap: '16px' }}>
          {[
            {
              q: 'Can I apply for multiple categories?',
              a: 'No, you can only register under one primary category. Choose the one that best represents your situation.'
            },
            {
              q: 'What if I do not have a bank account?',
              a: 'You can open a basic savings account at any bank or through mobile money services. Our team can help guide you through this process.'
            },
            {
              q: 'How long is the verification process?',
              a: 'Verification typically takes 30 days from submission. You will receive updates via email and SMS.'
            },
            {
              q: 'What happens after I am approved?',
              a: 'Once approved, you will be set up to receive bi-monthly payments directly to your account.'
            }
          ].map((item, idx) => (
            <div key={idx} style={{
              paddingBottom: '16px',
              borderBottom: idx < 3 ? '1px solid var(--border-light)' : 'none'
            }}>
              <h3 style={{
                fontSize: '15px',
                fontWeight: '600',
                marginBottom: '8px',
                color: 'var(--text-dark)',
                margin: '0 0 8px 0'
              }}>
                <i className="ti ti-help" style={{ marginRight: '8px', color: 'var(--primary-color)' }} aria-hidden="true"></i>
                {item.q}
              </h3>
              <p style={{
                fontSize: '14px',
                color: 'var(--text-secondary)',
                margin: 0,
                lineHeight: '1.6',
                paddingLeft: '24px'
              }}>
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

